import {call, put} from 'redux-saga/effects';
import {receiveNonRevAndRevFacilitiesData, errorRetrievingNonRevAndRevFacilitiesData} from "../actions/nonRevAndRevFacilitiesActions";
import {fetchNonRevAndRevFacilitiesData} from "../api/fetchFacilitiesData";

export default function* getNonRevAndRevFacilitiesData(action) {
    try {
        const rawFacilitiesData = yield call(fetchNonRevAndRevFacilitiesData);
        yield put(receiveNonRevAndRevFacilitiesData(rawFacilitiesData));
    } catch (e) {
        console.log(e);
        yield put(errorRetrievingNonRevAndRevFacilitiesData(e.message));
    }
}



// WEBPACK FOOTER //
// ./src/sagas/nonRevAndRevFacilitiesSaga.js